
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

// /yangcheng-test/LoveHelp/RefrshListLoveHelpSingle 列表刷新单个  get
//发布爱心求助
// /yangcheng-test/LoveHelp/BeforehandPayNeighborrecharge  预先支付捐款信息 post 
// /yangcheng-test/LoveHelp/UpdateLoveHelpStatus 更新状态 put
/**
 * 睦邻首页显示 睦邻首页列表查询
 * @returns
 */
 export const getLoveHelpHomeList = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/LoveHelp/GetHomeList`, {params: data})
}
//取消求助理由
export const putCancelLoveHelp = (data: any): Promise<any> => {
    return axios.put(`${baseURL}/LoveHelp/CancelLoveHelp`,  data)
}
//前端分页查询
export const getLoveHelp = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/LoveHelp`, {params: data})
}
//前端分页查询 根据唯一id
export const getLoveHelpById = (id: any): any => {
    return axios.get(`${baseURL}/LoveHelp/${id}`)
}
//发布  
export const putPublicLoveHelp = (id: any): any => {
    return axios.put(`${baseURL}/LoveHelp/PublicLoveHelp/${id}`)
}
// 预先支付捐款信息
export const postBeforehandPayNeighborrecharge = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/LoveHelp/BeforehandPayNeighborrecharge`, data)
}

 